var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{on:{"click":_vm.sendMockData}},[_vm._v(" + mock links ")])
}
var staticRenderFns = []

export { render, staticRenderFns }